import { connect } from 'react-redux';
import FilterIdentifierPanel from './FilterIdentifierPanel';
import { getFilterIdentifierCount, resetSingleFilter } from '../store/filtersSlice';

const mapState = state => ({
  active: state.loadingManagement.filters.active,
  authorizationSelection: state.loadingManagement.filters.authorizationSelection,
  carrierName: state.loadingManagement.filters.carrierName,
  exchange: state.loadingManagement.filters.exchange,
  extendedLoadingSelection: state.loadingManagement.filters.extendedLoadingSelection,
  filterIdentifierCount: getFilterIdentifierCount(state),
  inventoryOwner: state.loadingManagement.filters.inventoryOwner,
  limitType: state.loadingManagement.filters.limitType,
  loadingAllowed: state.loadingManagement.filters.loadingAllowed,
  location: state.loadingManagement.filters.location,
  nameShort: state.loadingManagement.filters.nameShort,
  product: state.loadingManagement.filters.product,
  state: state.loadingManagement.filters.state,
  status: state.loadingManagement.filters.status,
  supplier: state.loadingManagement.filters.supplier,
  type: state.loadingManagement.filters.type,
});

export default connect(mapState, { resetSingleFilter })(FilterIdentifierPanel);
